import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { withIcon } from '../Icon';
export var StyledHelpCircle = /*#__PURE__*/styled.path.withConfig({
  displayName: "StyledHelpCircle",
  componentId: "c11n-8-111-1__sc-1gopb49-0"
})(["fill:currentColor;"]);
export var StyledHelpQuestion = /*#__PURE__*/styled.path.withConfig({
  displayName: "StyledHelpQuestion",
  componentId: "c11n-8-111-1__sc-1gopb49-1"
})(["fill:#fff;stroke:none;"]);
export var HelpSVG = function HelpSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement(StyledHelpCircle, {
    d: "M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2zm-.426 21.25a1.355 1.355 0 1 1 1.256-1.35 1.3 1.3 0 0 1-1.256 1.35zm2.9-7.351c-1.446.879-1.737 1.392-1.875 2.285-.191.846-.68.937-1.032.937a1.092 1.092 0 0 1-1.124-1.221v-.147a2.868 2.868 0 0 1 1.684-2.569c1.355-.847 1.792-1.456 1.792-2.506a1.952 1.952 0 0 0-2.09-1.986 2.144 2.144 0 0 0-2.167 1.57 1.093 1.093 0 0 1-1.107.83.973.973 0 0 1-1.055-1.065 2.482 2.482 0 0 1 .284-1.158C12.4 9.55 13.963 8.75 15.969 8.75c2.71 0 4.531 1.54 4.531 3.832a3.645 3.645 0 0 1-2.024 3.318z"
  }), /*#__PURE__*/React.createElement(StyledHelpQuestion, {
    d: "M15.969 8.75c-2.006 0-3.574.8-4.185 2.119a2.482 2.482 0 0 0-.284 1.158.973.973 0 0 0 1.055 1.064 1.093 1.093 0 0 0 1.107-.83 2.144 2.144 0 0 1 2.167-1.57 1.952 1.952 0 0 1 2.09 1.986c0 1.05-.437 1.659-1.792 2.506a2.868 2.868 0 0 0-1.684 2.569v.148a1.092 1.092 0 0 0 1.126 1.222c.352 0 .841-.091 1.032-.937.138-.893.429-1.406 1.875-2.285a3.645 3.645 0 0 0 2.024-3.318c0-2.292-1.821-3.832-4.531-3.832z"
  }), /*#__PURE__*/React.createElement(StyledHelpQuestion, {
    d: "M15.574 20.547A1.355 1.355 0 1 0 16.83 21.9a1.3 1.3 0 0 0-1.256-1.353z"
  }));
};
HelpSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HelpSVG);